import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { paymentMethodFilterConfig } from '../../../configs/payment-method-filter-config';

export const PaymentMethodFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Method'
      config={paymentMethodFilterConfig}
    />
  );
};
